import React from 'react'
import { useTranslation } from "react-i18next";
import { useGetMasterCommissionListQuery } from '../../redux/userApi';

function CommissionHistory() {
    const { t } = useTranslation();
    const {data:commissions, isLoading:commissionLoading} = useGetMasterCommissionListQuery()

    const showCommissionData = () => {
      return commissions?.map((sub, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{sub.user_name}</td>
          <td>{sub.email}</td>
          <td>{sub.amount}</td>
        </tr>
      ));
    };

    return (
      <div className="p-2">
        <div className="table-responsive trade_scrool_table">
          <table className="table table-striped mb-0 ">
            <thead>
              <tr>
                <th>{t("Sr. No.")}</th>
                <th>{t("Username")}</th>
                <th>{t("Email")} </th>
                <th>{t("Amount")}</th>
              </tr>
            </thead>
            {/* <tbody>{showTableHtmlCrypto()}</tbody> */}
            <tbody>{showCommissionData()}</tbody>
          </table>
        </div>
      </div>
    );
}

export default CommissionHistory